import React from 'react';

interface PerforationDividerProps {
  className?: string;
  dense?: boolean;
}

export const PerforationDivider: React.FC<PerforationDividerProps> = ({className = '', dense = false}) => {
  const pattern = dense ? 'border-dotted' : 'border-dashed';

  return <div className={`border-l-2 border-gray-300 ${pattern} ${className}`} />;
};
